import React from 'react';
import { ReactComponent as Back } from '../../../assets/svg/chevron-left.svg';
import { ReactComponent as Back2 } from '../../../assets/svg/back-icon.svg';

import { ReactComponent as AssignedIcn } from '../../../assets/svg/mc-assign.svg';
import { ReactComponent as CopiedIcn } from '../../../assets/svg/mc-copied.svg';
import { ReactComponent as CopyVerifiedIcn } from '../../../assets/svg/mc-copy-verified.svg';
import { ReactComponent as ReceivedIcn } from '../../../assets/svg/mc-received.svg';
import { ReactComponent as RegisteredIcn } from '../../../assets/svg/mc-registered.svg';
import { ReactComponent as StateChangeIcn } from '../../../assets/svg/mc-state-change.svg';
import { ReactComponent as ReleasedIcn } from '../../../assets/svg/mc-released.svg';

import { withRouter } from '../../../services/withRoute';
import LoadingBar from '../../components/global/loadingBar';
import { gql } from '@apollo/client';
import ProjectsGraphQl from '../../../controllers/projectsGraphQl';
import _ from 'lodash';
import InfiniteScroll from 'react-infinite-scroll-component';
import moment from 'moment';
const getMemoryCardLogs = gql`
	query McTransactionLogs(
		$workspaceIds: [String!]
		$filters: McTransactionListFiltersInput
		$mcIdentifier: String
	) {
		mcTransactionLogs(workspaceIds: $workspaceIds, filters: $filters) {
			data {
				id
				status
				qrCode
				mcId
				description
				createdAt
				createdBy {
					id
					name
				}
				tenantId
				workspaceId
				userId
				userName
				eventId
				eventName
				projectId
				projectName
				isReceived
				backupLogs {
					hddId
					hddQrCode
					backupSize
					backupPath
					numberOfFiles
					isVerified
					createdBy {
						id
						name
					}
					verifiedBy {
						id
						name
					}
				}
				isEmpty
				isDamaged
				updatedBy
				reMappedEvent {
					tenantId
					workspaceId
					projectId
					projectName
					projectSlNo
					eventId
					eventName
					eventSlNo
				}
				releasedBy {
					id
					name
				}
				releasedAt
			}
			totalPages
			totalDocs
			limit
			currentPage
			hasNextPage
			hasPrevPage
			prevPage
			nextPage
		}
		memoryCard(mcIdentifier: $mcIdentifier) {
			qrCode
			createdAt
			createdBy
			status
		}
		vendorUsers {
			firstName
			id
			displayName
			lastName
		}
	}
`;

const getOnlyMemoryCardLogs = gql`
	query MemoryCard($filters: McTransactionListFiltersInput, $workspaceIds: [String!]) {
		mcTransactionLogs(workspaceIds: $workspaceIds, filters: $filters) {
			data {
				createdAt
				createdBy {
					id
					name
				}
				description
				eventId
				isEmpty
				id
				backupLogs {
					hddId
					hddQrCode
					backupSize
					backupPath
					numberOfFiles
					isVerified
					createdBy {
						id
						name
					}
					verifiedBy {
						id
						name
					}
				}
				isReceived
				notes {
					_id
					message
					createdBy
					createdAt
				}
				qrCode
				reMappedEvent {
					tenantId
					workspaceId
					projectId
					projectName
					projectSlNo
					eventId
					eventName
					eventSlNo
				}
				releasedAt
				releasedBy {
					id
					name
				}
				status
				updatedBy
				userId
				userName
				eventName
				projectName
				projectId
				workspaceId
				tenantId
			}
			totalPages
			totalDocs
			limit
			currentPage
			hasNextPage
			hasPrevPage
			prevPage
			nextPage
		}
	}
`;

class MemoryCardLogs extends ProjectsGraphQl {
	constructor() {
		super();
		this.state = {
			limit: 50,
			currentViewPage: 1,
			memoryCardLogsList: [],
			lengthOfList: 0,
			isPageLoading: false,
			isLoading: true,
			hasNextPage: true,
			memoryCardInfo: null,
			columns: [
				{ title: 'Date & Time' },
				{ title: '' },
				{ title: 'Type' },
				{ title: 'Description' },
			],
		};
	}
	componentDidMount = () => {
		let filters = {
			filters: {
				limit: this.state.limit,
				page: this.state.currentViewPage,
				qrCode: this.props.params.qrcode,
			},
			mcIdentifier: this.props.params.qrcode,
		};
		this.getMemoryCardLogs(getMemoryCardLogs, filters);
	};
	onClickNextPage = async () => {
		if (this.state.currentViewPage < this.state.totalPages) {
			this.setState(
				{
					currentViewPage: this.state.currentViewPage + 1,
				},
				async () => {
					await this.fetchMoreMCLogs();
				},
			);
		}
	};
	fetchMoreMCLogs = async () => {
		let json = {
			filters: {
				limit: this.state.limit,
				page: this.state.currentViewPage,
				qrCode: this.props.params.qrcode,
			},
		};
		this.getMemoryCardLogs(getOnlyMemoryCardLogs, json);
	};
	goBack = (e) => {
		this.props.navigate(-1);
	};
	render() {
		let lastMcLog = {};
		return (
			<>
				<div className="assign-receive-container mc-logs-assign-receive-container">
					<div className="arc-header">
						<div className="back-btn" onClick={(e) => this.goBack(e)}>
							<Back2 />
						</div>
						<div className="arc-header-container">
							<div className="arch-item">
								<span className="">
									<p>Memory Card</p>
									<b>{this.props.params.qrcode}</b>
								</span>
							</div>
							<div className="next-btn">
								<Back />
							</div>
							<div className="arch-item">
								<span className="arc-title">Memory card Logs</span>
							</div>
						</div>
					</div>
					<div className={'table shoots-table'} id={'scrollableDiv-shoots-vendors'}>
						{this.state.isLoading === true ? (
							<LoadingBar />
						) : (
							<div className="projects-table-outer-container">
								{_.size(this.state.memoryCardLogsList) === 0 &&
								_.size(this.state.memoryCardInfo) === 0 ? (
									<div
										style={{
											display: 'flex',
											width: '100%',
											height: '100%',
											alignItems: 'center',
											justifyContent: 'center',
											color: '#E4E5E6',
											fontFamily: 'Inter Medium',
											fontSize: '14px',
											fontWeight: 500,
											lineHeight: '16px',
											letterSpacing: '-0.3px',
										}}
									>
										No Memory Card logs found
									</div>
								) : (
									<InfiniteScroll
										dataLength={this.state.lengthOfList}
										next={() => {
											this.onClickNextPage();
										}}
										hasMore={this.state.hasNextPage}
										loader={
											<div
												style={{
													color: '#fff',
													textAlign: 'center',
													width: '100%',
													padding: '20px',
												}}
											>
												Loading...
											</div>
										}
										scrollableTarget={'scrollableDiv-shoots-vendors'}
										scrollThreshold={0.5}
									>
										<table className="shootTable">
											<thead>
												<tr>
													{_.map(this.state.columns, (column, key) => {
														return <th>{column.title}</th>;
													})}
												</tr>
											</thead>
											<tbody>
												{_.reverse(
													_.map(
														_.sortBy(this.state.memoryCardLogsList, [
															'id',
														]),
														(mclog, idx) => {
															let actualLastMcLog = lastMcLog;
															lastMcLog = mclog;
															if (
																(this.state.hasNextPage === false &&
																	idx === 0 &&
																	mclog.status !== 'busy') ||
																(this.state.hasNextPage === true &&
																	idx === 0)
															) {
																return null;
															}

															return (
																<tr>
																	<td>
																		{moment
																			.unix(mclog.createdAt)
																			.format(
																				'DD MMM YYYY, hh:mm a',
																			)}
																	</td>
																	<td>
																		{idx === 0 &&
																		this.state.hasNextPage ===
																			false &&
																		mclog.status === 'busy' ? (
																			<AssignedIcn />
																		) : actualLastMcLog.status ===
																				'ready' &&
																		  mclog.status === 'busy' &&
																		  (mclog.isReceived ===
																				false ||
																				mclog.isReceived ===
																					null) ? (
																			<AssignedIcn />
																		) : actualLastMcLog.status ===
																				'busy' &&
																		  mclog.status ===
																				'ready' ? (
																			<ReleasedIcn />
																		) : (actualLastMcLog.isEmpty ===
																				null ||
																				actualLastMcLog.isEmpty ===
																					false) &&
																		  (actualLastMcLog.isReceived ===
																				null ||
																				actualLastMcLog.isReceived ===
																					false) &&
																		  mclog.isReceived ===
																				true &&
																		  mclog.isEmpty === true ? (
																			<ReceivedIcn />
																		) : (actualLastMcLog.status ===
																				'busy' &&
																				mclog.reMappedEvent !==
																					null &&
																				_.has(
																					mclog.reMappedEvent,
																					'eventId',
																				) &&
																				mclog.reMappedEvent
																					.eventId) ||
																		  (_.size(
																				mclog.backupLogs,
																		  ) === 0 &&
																				(actualLastMcLog.isEmpty ===
																					false ||
																					actualLastMcLog.isEmpty ===
																						null) &&
																				mclog.isEmpty ===
																					true) ||
																		  (_.size(
																				mclog.backupLogs,
																		  ) === 0 &&
																				actualLastMcLog.isEmpty ===
																					true &&
																				(mclog.isEmpty ===
																					false ||
																					mclog.isEmpty ===
																						null)) ? (
																			<StateChangeIcn />
																		) : (actualLastMcLog.isReceived ===
																				false ||
																				actualLastMcLog.isReceived ===
																					null) &&
																		  mclog.isReceived ===
																				true ? (
																			<ReceivedIcn />
																		) : (mclog.isReceived ===
																				true &&
																				_.size(
																					mclog.backupLogs,
																				) >
																					_.size(
																						mclog.actualLastMcLog,
																					) &&
																				mclog.backupLogs[0]
																					.isVerified !==
																					true) ||
																		  (_.size(
																				mclog.backupLogs,
																		  ) > 0 &&
																				(actualLastMcLog.isEmpty ===
																					false ||
																					actualLastMcLog.isEmpty ===
																						null) &&
																				mclog.isEmpty ===
																					true &&
																				mclog.backupLogs[0]
																					.isVerified !==
																					true) ||
																		  (actualLastMcLog.isEmpty ===
																				true &&
																				(mclog.isEmpty ===
																					false ||
																					mclog.isEmpty ===
																						null)) ? (
																			<CopiedIcn />
																		) : mclog.isReceived ===
																				true &&
																		  _.size(mclog.backupLogs) >
																				0 &&
																		  _.has(
																				mclog.backupLogs[0],
																				'isVerified',
																		  ) &&
																		  mclog.backupLogs[0]
																				.isVerified ==
																				true ? (
																			<CopyVerifiedIcn />
																		) : _.size(
																				mclog.backupLogs,
																		  ) === 0 &&
																		  actualLastMcLog.status ===
																				'busy' &&
																		  mclog.status ===
																				'busy' ? (
																			<AssignedIcn />
																		) : null}
																	</td>
																	<td>
																		{idx === 0 &&
																		this.state.hasNextPage ===
																			false &&
																		mclog.status === 'busy'
																			? 'MC assigned '
																			: actualLastMcLog.status ===
																					'ready' &&
																			  mclog.status ===
																					'busy' &&
																			  (mclog.isReceived ===
																					false ||
																					mclog.isReceived ===
																						null)
																			? 'MC assigned '
																			: actualLastMcLog.status ===
																					'busy' &&
																			  mclog.reMappedEvent !==
																					null &&
																			  _.has(
																					mclog.reMappedEvent,
																					'eventId',
																			  ) &&
																			  mclog.reMappedEvent
																					.eventId
																			? 'MC reassigned'
																			: actualLastMcLog.status ===
																					'busy' &&
																			  mclog.status ===
																					'ready'
																			? 'Card released'
																			: (actualLastMcLog.isEmpty ===
																					null ||
																					actualLastMcLog.isEmpty ===
																						false) &&
																			  (actualLastMcLog.isReceived ===
																					null ||
																					actualLastMcLog.isReceived ===
																						false) &&
																			  mclog.isReceived ===
																					true &&
																			  mclog.isEmpty === true
																			? 'MC recieved'
																			: _.size(
																					mclog.backupLogs,
																			  ) === 0 &&
																			  (actualLastMcLog.isEmpty ===
																					false ||
																					actualLastMcLog.isEmpty ===
																						null) &&
																			  mclog.isEmpty === true
																			? 'Card state shift'
																			: _.size(
																					mclog.backupLogs,
																			  ) === 0 &&
																			  actualLastMcLog.isEmpty ===
																					true &&
																			  (mclog.isEmpty ===
																					false ||
																					mclog.isEmpty ===
																						null)
																			? 'Card state shift'
																			: (actualLastMcLog.isReceived ===
																					false ||
																					actualLastMcLog.isReceived ===
																						null) &&
																			  mclog.isReceived ===
																					true
																			? 'MC recieved'
																			: mclog.isReceived ===
																					true &&
																			  _.size(
																					mclog.backupLogs,
																			  ) >
																					_.size(
																						mclog.actualLastMcLog,
																					) &&
																			  mclog.backupLogs[0]
																					.isVerified !==
																					true
																			? 'Card Copied'
																			: _.size(
																					mclog.backupLogs,
																			  ) > 0 &&
																			  (actualLastMcLog.isEmpty ===
																					false ||
																					actualLastMcLog.isEmpty ===
																						null) &&
																			  mclog.isEmpty === true
																			? 'Marked as empty'
																			: actualLastMcLog.isEmpty ===
																					true &&
																			  (mclog.isEmpty ===
																					false ||
																					mclog.isEmpty ===
																						null)
																			? 'Card state shift'
																			: mclog.isReceived ===
																					true &&
																			  _.size(
																					mclog.backupLogs,
																			  ) > 0 &&
																			  _.has(
																					mclog
																						.backupLogs[0],
																					'isVerified',
																			  ) &&
																			  mclog.backupLogs[0]
																					.isVerified ==
																					true
																			? 'Copied Verified'
																			: _.size(
																					mclog.backupLogs,
																			  ) === 0 &&
																			  actualLastMcLog.status ===
																					'busy' &&
																			  mclog.status ===
																					'busy'
																			? 'MC assigned '
																			: null}
																	</td>
																	<td>
																		{(idx === 0 &&
																			this.state
																				.hasNextPage ===
																				false &&
																			mclog.status ===
																				'busy') ||
																		(actualLastMcLog.status ===
																			'ready' &&
																			mclog.status ===
																				'busy' &&
																			(mclog.isReceived ===
																				false ||
																				mclog.isReceived ===
																					null)) ? (
																			`Assigned to ${_.capitalize(
																				mclog.userName,
																			)}${
																				mclog.eventName &&
																				mclog.projectName
																					? ` (${mclog.eventName} - ${mclog.projectName}) `
																					: ''
																			} by ${
																				mclog.createdBy &&
																				_.has(
																					mclog.createdBy,
																					'name',
																				) &&
																				mclog.createdBy.name
																					? ` ${_.capitalize(
																							mclog
																								.createdBy
																								.name,
																					  )}`
																					: ''
																			}`
																		) : actualLastMcLog.status ===
																				'busy' &&
																		  mclog.reMappedEvent !==
																				null &&
																		  _.has(
																				mclog.reMappedEvent,
																				'eventId',
																		  ) &&
																		  mclog.reMappedEvent
																				.eventId ? (
																			`Reassigned by ${
																				mclog.createdBy &&
																				_.has(
																					mclog.createdBy,
																					'name',
																				) &&
																				mclog.createdBy.name
																					? ` ${_.capitalize(
																							mclog
																								.createdBy
																								.name,
																					  )}`
																					: ''
																			}`
																		) : actualLastMcLog.status ===
																				'busy' &&
																		  mclog.status ===
																				'ready' ? (
																			`Released by ${
																				mclog.releasedBy &&
																				_.has(
																					mclog.releasedBy,
																					'name',
																				) &&
																				mclog.releasedBy
																					.name
																					? ` ${_.capitalize(
																							mclog
																								.releasedBy
																								.name,
																					  )}`
																					: mclog.createdBy &&
																					  _.has(
																							mclog.createdBy,
																							'name',
																					  ) &&
																					  mclog
																							.createdBy
																							.name
																					? ` ${_.capitalize(
																							mclog
																								.createdBy
																								.name,
																					  )}`
																					: ''
																			}`
																		) : (actualLastMcLog.isEmpty ===
																				null ||
																				actualLastMcLog.isEmpty ===
																					false) &&
																		  (actualLastMcLog.isReceived ===
																				null ||
																				actualLastMcLog.isReceived ===
																					false) &&
																		  mclog.isReceived ===
																				true &&
																		  mclog.isEmpty === true ? (
																			`Recieved as Empty from ${_.capitalize(
																				mclog.userName,
																			)}${
																				mclog.createdBy &&
																				_.has(
																					mclog.createdBy,
																					'name',
																				) &&
																				mclog.createdBy.name
																					? ` by ${_.capitalize(
																							mclog
																								.createdBy
																								.name,
																					  )}`
																					: ''
																			}`
																		) : _.size(
																				mclog.backupLogs,
																		  ) === 0 &&
																		  (actualLastMcLog.isEmpty ===
																				false ||
																				actualLastMcLog.isEmpty ===
																					null) &&
																		  mclog.isEmpty === true ? (
																			`Marked as Empty ${
																				mclog.createdBy &&
																				_.has(
																					mclog.createdBy,
																					'name',
																				) &&
																				mclog.createdBy.name
																					? `by ${_.capitalize(
																							mclog
																								.createdBy
																								.name,
																					  )}`
																					: ''
																			}`
																		) : _.size(
																				mclog.backupLogs,
																		  ) === 0 &&
																		  actualLastMcLog.isEmpty ===
																				true &&
																		  (mclog.isEmpty ===
																				false ||
																				mclog.isEmpty ===
																					null) ? (
																			`Unmarked as Empty ${
																				mclog.createdBy &&
																				_.has(
																					mclog.createdBy,
																					'name',
																				) &&
																				mclog.createdBy.name
																					? `by ${_.capitalize(
																							mclog
																								.createdBy
																								.name,
																					  )}`
																					: ''
																			}`
																		) : (actualLastMcLog.isReceived ===
																				false ||
																				actualLastMcLog.isReceived ===
																					null) &&
																		  mclog.isReceived ===
																				true ? (
																			`Recieved from ${_.capitalize(
																				mclog.userName,
																			)}${
																				mclog.createdBy &&
																				_.has(
																					mclog.createdBy,
																					'name',
																				) &&
																				mclog.createdBy.name
																					? ` by ${_.capitalize(
																							mclog
																								.createdBy
																								.name,
																					  )}`
																					: ''
																			}`
																		) : mclog.isReceived ===
																				true &&
																		  _.size(mclog.backupLogs) >
																				_.size(
																					mclog.actualLastMcLog,
																				) &&
																		  mclog.backupLogs[0]
																				.isVerified !==
																				true ? (
																			<div className="column-td-container">
																				{_.map(
																					mclog.backupLogs,
																					(bkup, inx) => {
																						return (
																							<div>
																								<span>
																									{`${
																										bkup.backupSize !==
																											null ||
																										bkup.backupSize !==
																											undefined
																											? bkup.backupSize
																											: ''
																									} GB`}{' '}
																									copied
																									to{' '}
																								</span>
																								<span className="column-td-hdd-text">
																									{
																										bkup.hddQrCode
																									}
																								</span>
																								<span>{`${
																									bkup.createdBy &&
																									_.has(
																										bkup.createdBy,
																										'name',
																									) &&
																									bkup
																										.createdBy
																										.name
																										? ` by ${_.capitalize(
																												bkup
																													.createdBy
																													.name,
																										  )}`
																										: ''
																								}`}</span>
																							</div>
																						);
																					},
																				)}
																			</div>
																		) : _.size(
																				mclog.backupLogs,
																		  ) > 0 &&
																		  (actualLastMcLog.isEmpty ===
																				false ||
																				actualLastMcLog.isEmpty ===
																					null) &&
																		  mclog.isEmpty === true ? (
																			`Marked as Empty ${
																				mclog.createdBy &&
																				_.has(
																					mclog.createdBy,
																					'name',
																				) &&
																				mclog.createdBy.name
																					? ` ${_.capitalize(
																							mclog
																								.createdBy
																								.name,
																					  )}`
																					: ''
																			}`
																		) : actualLastMcLog.isEmpty ===
																				true &&
																		  (mclog.isEmpty ===
																				false ||
																				mclog.isEmpty ===
																					null) ? (
																			`Unmarked as Empty ${
																				mclog.createdBy &&
																				_.has(
																					mclog.createdBy,
																					'name',
																				) &&
																				mclog.createdBy.name
																					? ` ${_.capitalize(
																							mclog
																								.createdBy
																								.name,
																					  )}`
																					: ''
																			}`
																		) : mclog.isReceived ===
																				true &&
																		  _.size(mclog.backupLogs) >
																				0 &&
																		  _.has(
																				mclog.backupLogs[0],
																				'isVerified',
																		  ) &&
																		  mclog.backupLogs[0]
																				.isVerified ==
																				true ? (
																			`${
																				mclog.backupLogs[0]
																					.backupSize !==
																				null
																					? `${mclog.backupLogs[0].backupSize} GB`
																					: ''
																			} copy to ${
																				mclog.backupLogs[0]
																					.hddQrCode
																			} verified by ${
																				mclog.backupLogs[0]
																					.verifiedBy &&
																				_.has(
																					mclog
																						.backupLogs[0]
																						.verifiedBy,
																					'name',
																				) &&
																				mclog.backupLogs[0]
																					.verifiedBy.name
																					? ` ${_.capitalize(
																							mclog
																								.backupLogs[0]
																								.verifiedBy
																								.name,
																					  )}`
																					: ''
																			}`
																		) : _.size(
																				mclog.backupLogs,
																		  ) === 0 &&
																		  actualLastMcLog.status ===
																				'busy' &&
																		  mclog.status ===
																				'busy' ? (
																			`Assigned to ${_.capitalize(
																				mclog.userName,
																			)}${
																				mclog.eventName &&
																				mclog.projectName
																					? ` (${mclog.eventName} - ${mclog.projectName}) `
																					: ''
																			} by ${
																				mclog.createdBy &&
																				_.has(
																					mclog.createdBy,
																					'name',
																				) &&
																				mclog.createdBy.name
																					? ` ${_.capitalize(
																							mclog
																								.createdBy
																								.name,
																					  )}`
																					: ''
																			}`
																		) : null}
																	</td>
																</tr>
															);
														},
													),
												)}
												{this.state.hasNextPage === false &&
												this.state.memoryCardInfo &&
												_.has(this.state.memoryCardInfo, 'createdAt') &&
												this.state.memoryCardInfo.createdAt ? (
													<tr>
														<td>
															{moment
																.unix(
																	this.state.memoryCardInfo
																		.createdAt,
																)
																.format('DD MMM YYYY, hh:mm a')}
														</td>
														<td>
															<RegisteredIcn />
														</td>
														<td>MC Registered</td>
														<td>
															{_.has(
																this.state.memoryCardInfo,
																'createdBy',
															) && this.state.memoryCardInfo.createdBy
																? `By ${
																		_.find(
																			this.state.vendorUsers,
																			{
																				id: this.state
																					.memoryCardInfo
																					.createdBy,
																			},
																		)
																			? _.find(
																					this.state
																						.vendorUsers,
																					{
																						id: this
																							.state
																							.memoryCardInfo
																							.createdBy,
																					},
																			  ).name
																			: ''
																  }`
																: _.size(
																		this.state
																			.memoryCardLogsList,
																  ) > 0 &&
																  this.state.memoryCardLogsList[0]
																		.status === 'ready' &&
																  _.has(
																		this.state
																			.memoryCardLogsList[0],
																		'createdBy',
																  ) &&
																  this.state.memoryCardLogsList[0]
																		.createdBy
																? `by ${_.capitalize(
																		this.state
																			.memoryCardLogsList[0]
																			.createdBy,
																  )}`
																: ''}
														</td>
													</tr>
												) : null}
											</tbody>
										</table>
									</InfiniteScroll>
								)}
							</div>
						)}
					</div>
				</div>
			</>
		);
	}
}
export default withRouter(MemoryCardLogs);
